import { CircleComponent } from './circle_component';
export default CircleComponent;
